// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://zejqtgmwrdhojwdocwsg.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InplanF0Z213cmRob2p3ZG9jd3NnIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTYzODYwNTIsImV4cCI6MjA3MTk2MjA1Mn0.H3G9MsUWXAONN5BN5_fqvX6oWPqanzlR3zh-lXROqhM";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});